'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect, useMemo } from 'react';

import { Pagination } from '../../pagination/pagination';

export default function SearchResultsPaginationClient({
  vehiclesMeta,
}: {
  vehiclesMeta: any;
}) {
  const searchParams = useSearchParams();
  const pathname = usePathname();

  const pageFromUrl = Number(searchParams.get('page') || '1');
  const totalPages = Math.ceil(
    (vehiclesMeta?.filterCount || 0) / vehiclesMeta.pageSize
  );

  const safePage =
    totalPages > 0 && (pageFromUrl < 1 || pageFromUrl > totalPages)
      ? 1
      : pageFromUrl;

  useEffect(() => {
    if (totalPages > 0 && (pageFromUrl < 1 || pageFromUrl > totalPages) && pathname) {
      const newSearchParams = new URLSearchParams(searchParams.toString());

      newSearchParams.set('page', '1');
      const newUrl = `${pathname}?${newSearchParams.toString()}`;

      // Use window.location for immediate redirect
      window.location.replace(newUrl);
    }
  }, [pageFromUrl, totalPages, pathname, searchParams]);

  const clientVehiclesMeta = useMemo(
    () => ({
      ...vehiclesMeta,
      currentPage: safePage,
    }),
    [vehiclesMeta, safePage]
  );

  if ((vehiclesMeta?.filterCount as number) <= vehiclesMeta.pageSize) {
    return null;
  }

  return (
    <Pagination
      itemsMeta={clientVehiclesMeta}
      pageSize={vehiclesMeta.pageSize}
    />
  );
}
